import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Banner.module.sass';

const Banner = ({ image, classes }) =>
  <div className={cn(styles.bannerContainer, classes)}>
    <img src={image} className={styles.bannerImg} />
  </div>

Banner.propTypes = {
  image: PropTypes.string,
  classes: PropTypes.string,
};

export default Banner;
